<template>
  <v-card>
    <v-card-title class="text-break">{{promo.name}}</v-card-title>
    <v-card-text>
      <v-img :src="promo.image"
             eager
             contain
             height="145"
      ></v-img>
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-chip>${{ promo.price }}</v-chip>
      <v-spacer></v-spacer>
      <!--SHOW-->
      <span v-if="quantity > 0" class="px-3">x{{ quantity }}</span>
      <!--ADD-->
      <v-btn
             fab small color="primary"
             @click="dialog = true"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-card-actions>
    <customer-promo-dialog
        v-if="dialog"
        v-model="dialog"
        :promo="promo"
        :stock="stock"
    />
  </v-card>
</template>

<script>
import CustomerPromoDialog from '../PromoDialog';

export default {
  name: "PromoCard",
  components: {
    CustomerPromoDialog,
  },
  props: {
    promo: {type: Object, required: true },
    stock: {type: Object, required: true },
    quantity: {type: Number, required: false },
  },
  data(){
    return {
      dialog: false,
    }
  },

}
</script>

<style scoped>

</style>
